import { props, saveAndNavigate } from './syllabus-block-utils';
import Block from './block';

export default {
  props,
  template: '#course-logo-block-template',
  data() {
    return Object.assign({
      title: '',
      showOnPublicSyllabus: true,
    }, this.rootData);
  },
  components: {
    Block
  },
  watch: {
    dataForSave() {
      this.$emit('block-update', this.dataForSave);
    },
  },
  computed: {
    dataForSave() {
      return {
        uuid: this.uuid,
        data: {
          title: this.title,
          showOnPublicSyllabus: this.showOnPublicSyllabus
        }
      };
    },
    courseLogo() {
      return this.$root.course.cinema_logo;
    },
  },
  methods: {
    navigateToSettings() {
      let opts = {
        title: 'Are you sure you want to leave?',
        body: `You are about to leave the Syllabus Creator to edit your course
        image, any changes will be saved`,
        cancel_btn_text: 'Return To Builder',
        ok_btn_text: 'Save & Continue'
      };
      const path = Kadenze.Routes.course_settings_path(this.$root.course.id) + '#course_info';

      Kadenze.UIUtil.confirmAction(
        opts.body, () => {
          this.$root.save(() => window.location = path);
        }, null, opts
      );
    }
  }
};
